import { PaymentMethod } from '../types/transaction';

export const getCashTracks = (
  paymentMethod: PaymentMethod,
  tradingBalance: number,
  tradingLimit: number,
  minThreshold = [0.04, 0.08],
): [number, number] => {
  // If payment method is not Trading Limit, return 100% TB and 0% TL
  if (paymentMethod !== PaymentMethod.TradingLimit) {
    return [100, 0];
  }

  const [leftMinThreshold, rightMinThreshold] = minThreshold;

  const clampToZero = (value: number) => (value < 0 ? 0 : value);
  const tradingBalanceRatio =
    clampToZero(tradingBalance) / clampToZero(tradingLimit);
  const isTradingBalanceFinite = Number.isFinite(tradingBalanceRatio);

  // Will return max TB if TL actually 0 / ratio is infinity
  if (!isTradingBalanceFinite) return [100, 0];

  const tradingLimitRatio = 1 - tradingBalanceRatio;

  if (tradingBalanceRatio !== 0 && tradingBalanceRatio < leftMinThreshold) {
    return [leftMinThreshold * 100, (1 - leftMinThreshold) * 100];
  }

  if (tradingLimitRatio !== 0 && tradingLimitRatio < rightMinThreshold) {
    return [(1 - rightMinThreshold) * 100, rightMinThreshold * 100];
  }

  return [tradingBalanceRatio * 100, tradingLimitRatio * 100];
};
